/**
 *
 * @constructor
 */
function NotificationsPage() {
    /**
     *
     */
    NotificationsPage.prototype.initialize = function (console) {
        this.id = "notifications";
        this.console = console;

        return this;
    };

    /**
     *
     */
    NotificationsPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.mode = 'error';
        this.console.Ui.turnOn("errorLogLevel");

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    NotificationsPage.prototype.leave = function () {
    };
}
